import { render, staticRenderFns } from "./sub-task.vue?vue&type=template&id=5c98e614&scoped=true&"
import script from "./sub-task.vue?vue&type=script&lang=js&"
export * from "./sub-task.vue?vue&type=script&lang=js&"
import style0 from "./sub-task.vue?vue&type=style&index=0&id=5c98e614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c98e614",
  null
  
)

export default component.exports